import { _firestore } from '../../firebase';
import { selectStoreConfig } from '../Layout/selectors';
import ActionTypes from './constants';

export function addReview(review) {
  return (dispatch, getState) => {
    const storeConfig = selectStoreConfig(getState());
    fetch(`${storeConfig.cloudFunctionsUrl}/postReview`, {
      method: 'post',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...review,
      }),
    })
      .then((res) => res.json())
      .then((_result) => {
        dispatch(reviewsChecked(true));
      });
  };
}

export function checkReview(orderId, orderType) {
  return (dispatch) => {
    _firestore
      .collection('Reviews')
      .where('orderId', '==', orderId)
      .get()
      .then((querySnapshot) => {
        var dataArray = [];
        querySnapshot.forEach((doc) => {
          dataArray.push({ _id: doc.id, ...doc.data() });
        });
        if (dataArray.length <= 0) {
         /* if (orderType === 3) {
            //orderType=3 is a reservations
            _firestore
              .collection('Reservations')
              .doc(orderId)
              .get()
              .then((doc) => {
                let obj = { _id: doc.id, ...doc.data() };
                obj.orderType = '3';
                dispatch(reviewsChecked(false, obj));
              });
          } else */ if (orderType === 4) {
            _firestore
              .collection('OtherDeliveries')
              .doc(orderId)
              .get()
              .then((doc) => {
                let obj = { _id: doc.id, ...doc.data() };
                _firestore
                  .collection('OrderSetup')
                  .where('storeId', '==', obj.storeId)
                  .get()
                  .then((querySnapshot1) => {
                    var dataArray1 = [];
                    querySnapshot1.forEach((doc1) => {
                      const data = doc1.data();
                      if (typeof data.autoDetectSpecialsWeb === 'undefined') {
                        data.autoDetectSpecialsWeb = true;
                      }
                      dataArray1.push({ _id: doc1.id, ...data });
                    });
                    if (dataArray1.length > 0) {
                      obj.orderType = '4';
                      dispatch(reviewsChecked(false, obj, dataArray1[0]));
                    } else {
                      obj.orderType = '4';
                      dispatch(reviewsChecked(false, obj));
                    }
                  });
              });
          } else {
            _firestore
              .collection('Orders')
              .doc(orderId)
              .get()
              .then((doc) => {
                let obj = { _id: doc.id, ...doc.data() };
                _firestore
                  .collection('OrderSetup')
                  .where('storeId', '==', obj.storeId)
                  .get()
                  .then((querySnapshot1) => {
                    var dataArray1 = [];
                    querySnapshot1.forEach((doc1) => {
                      const data = doc1.data();
                      if (typeof data.autoDetectSpecialsWeb === 'undefined') {
                        data.autoDetectSpecialsWeb = true;
                      }
                      dataArray1.push({ _id: doc1.id, ...data });
                    });
                    if (dataArray1.length > 0) {
                      dispatch(reviewsChecked(false, obj, dataArray1[0]));
                    } else {
                      dispatch(reviewsChecked(false, obj));
                    }
                  });
              });
          }
        } else {
          dispatch(reviewsChecked(true));
        }
      });
  };
}

function reviewsChecked(flag, orderReview, orderSetup) {
  return {
    type: ActionTypes.FetchReviewStatus,
    flag,
    orderReview,
    orderSetup,
  };
}
